var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary w-100 mb-2",on:{"click":function($event){$event.preventDefault();return _vm.confirmModal($event)}}},[_vm._v(_vm._s(_vm.buttonText))])}
var staticRenderFns = []

export { render, staticRenderFns }